import { FC, useState } from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { ModalComponent } from 'componets/common';
import { FormItem, SubmitButton, TextField } from 'componets/form';
import { FieldData, ModalProps } from 'models';
import { Rules } from 'utils/constants';
import { AccountService } from 'api';
import { Coupon } from '../../../../../../models/Coupon';

interface Props extends ModalProps {
	onSetCoupon: (coupon: Coupon) => Promise<void>;
}

export const PrimaryMarketProjectPromoCodeModal: FC<Props> = ({
	isOpen,
	onClose,
	onSetCoupon,
}) => {
	const [coupon, setCoupon] = useState<Coupon>();
	const { t } = useTranslation();
	const [form] = Form.useForm();
	const [fields, setFields] = useState<FieldData[]>([]);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const onCloseModal = () => {
		onClose();
		setFields([{ name: ['code'], value: '' }]);
		setCoupon(undefined);
	};
	const onGetInfo = () => {
		setIsSubmitting(true);
		AccountService.getAvailableCoupon({
			code: form.getFieldValue('code'),
		})
			.then((res: Coupon) => {
				setCoupon(res);
			})
			.catch((e: { response: { data: any } }) => {
				const error = e?.response.data;
				if (error.message) {
					setFields([{ name: 'code', errors: [t(error.message)] }]);
				}
			})
			.finally(() => setIsSubmitting(false));
	};
	const onFinish = () => {
		if (coupon) {
			onSetCoupon(coupon).then(onCloseModal);
		}
	}
	return (
		<ModalComponent width={'600px'} isOpen={isOpen} onClose={onCloseModal} title={t('enterPromoCodeText')}>
			<div className="modal-content">
				<Form onFinish={onFinish} onFieldsChange={setFields} fields={fields} form={form}>
					<FormItem name="code" rules={[Rules.REQUIRED]} className="modal-form-item">
						<TextField label={t('promoCodeText')} disabled={!!coupon} />
					</FormItem>
					{coupon && (
						<div className="modal-text">
							<p>
								{t('promoDescriptionText', { code: coupon.code.toUpperCase() })}
								<br />
								<ul>
									{coupon.ranges.map((range, index) => (
										<li key={index}>
											{range.from && range.to && t('promoDescriptionOption1', range)}
											{range.from && !range.to && t('promoDescriptionOption2', range)}
										</li>
									))}
								</ul>
							</p>
						</div>
					)}
					<div className="modal-footer">
						{!coupon && (
							<SubmitButton
								htmlType="button"
								text={t('applyText')}
								loading={isSubmitting}
								onClick={() => onGetInfo()}
							/>
						)}
						{coupon && <SubmitButton text={t('gotItTextAndApply')} loading={isSubmitting} />}
					</div>
				</Form>
			</div>
		</ModalComponent>
	);
};
